var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuality(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 49.64,
    r: 20.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.34 47.82a8.26 8.26 0 0 0-1.69-11.73l-3.5-2.54a8.26 8.26 0 0 1-3.38-7.4l.37-4.31a8.26 8.26 0 0 0-7.76-9l-4.32-.24a8.26 8.26 0 0 1-6.84-4.4l-2-3.83a8.26 8.26 0 0 0-11.39-3.3L68.07 3.2a8.26 8.26 0 0 1-8.14 0l-3.76-2.13a8.26 8.26 0 0 0-11.38 3.34l-2 3.83a8.26 8.26 0 0 1-6.84 4.4l-4.32.24a8.26 8.26 0 0 0-7.76 9l.37 4.31a8.26 8.26 0 0 1-3.38 7.4l-3.5 2.54a8.26 8.26 0 0 0-1.69 11.73l2.64 3.42a8.26 8.26 0 0 1 1.16 8.05l-1.57 4a8.26 8.26 0 0 0 4.92 10.78l4.07 1.45a8.26 8.26 0 0 1 5.33 6.15l.78 3.8-10.39 33.77 16.48-5.16L49.35 128l9.37-30.63a8.26 8.26 0 0 0 10.07.37L78.65 128l10.26-13.88 16.48 5.16-10.64-32.64c.07-.23.13-.45.18-.69l.85-4.24a8.26 8.26 0 0 1 5.33-6.15l4.07-1.45a8.26 8.26 0 0 0 4.92-10.78l-1.57-4a8.26 8.26 0 0 1 1.16-8.05Zm-76.89 1.82A28.55 28.55 0 1 1 64 78.19a28.58 28.58 0 0 1-28.55-28.55Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.de6eb91dbf4f761789f3f1cc6ab78d24.svg";
export { ForwardRef as ReactComponent };